import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
      parent_company_id,
    },
    pause: false,
  }
}
